<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ $lang("payments.title_create") }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <v-date
              v-model="form.scheduled_at"
              :label="$lang('companies.payments.scheduled_at')"
              :error="!!validation.scheduled_at"
              :error-messages="!!validation.scheduled_at ? validation.scheduled_at : []"
            ></v-date>
            <v-text-field
              v-model="form.description"
              :label="$lang('companies.payments.description')"
              :error="!!validation.description"
              :error-messages="!!validation.description ? validation.description : []"
            ></v-text-field>
            <v-text-field
              v-model="form.amount"
              :label="$lang('companies.payments.amount')"
              :error="!!validation.amount"
              :error-messages="!!validation.amount ? validation.amount : []"
            ></v-text-field>
            <v-row>
              <v-col>
                <v-switch
                  v-model="form.is_disputed"
                  :label="$lang('companies.payments.is_disputed')"
                  :error="!!validation.is_disputed"
                  :error-messages="!!validation.is_disputed ? validation.is_disputed : []"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  v-model="form.is_paid"
                  :label="$lang('companies.payments.is_paid')"
                  :error="!!validation.is_paid"
                  :error-messages="!!validation.is_paid ? validation.is_paid : []"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-date
                  v-model="form.paid_at"
                  :label="$lang('companies.payments.paid_at')"
                  :error="!!validation.paid_at"
                  :error-messages="!!validation.paid_at ? validation.paid_at : []"
                  clearable
                ></v-date>
              </v-col>
              <v-col>
                <v-date
                  v-model="form.charged_at"
                  :label="$lang('companies.payments.charged_at')"
                  :error="!!validation.charged_at"
                  :error-messages="!!validation.charged_at ? validation.charged_at : []"
                  clearable
                ></v-date>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit()" :loading="loading" :disabled="loading">{{ $lang("main.crud.create") }}</v-btn>
      <v-btn color="error" @click="cancel()">{{ $lang("main.crud.cancel") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";

  import form from "@/pages/company-payments/mixins/form";

  import {
    CREATE_COMPANY_PAYMENTS,
    CREATE_COMPANY_PAYMENTS_RESET
  } from "@/store/company-payments/actions";

  export default {
    name: "CreationForm",
    props: {
      createData: {
        type: Object,
        required: true,
      }
    },
    mixins: [
      form
    ],
    methods: {
      resetAction() {
        return CREATE_COMPANY_PAYMENTS_RESET;
      },
      submitAction() {
        return CREATE_COMPANY_PAYMENTS;
      },
      submitActionOptions() {
        let data = {
          ...this.form,
          ...this.createData,
          };

        return data;
      }
    },
    computed: {
      ...mapState({
        loading: state => state.companyPayments.creationRequest.loading,
        validation: state => state.companyPayments.creationRequest.validation
      })
    },
  };
</script>

<style scoped>

</style>
